import { SvgIconProps } from '@mui/material';
import React from 'react';
import AthletesIconWrapper from './AthletesIcon';
import CoachesIconWrapper from './CoachesIcon';
import ParentsIconWrapper from './ParentsIcon';

export type AssignmentRoleType = 'athlete' | 'coach' | 'parent';

const RoleTypeIcon: React.FC<SvgIconProps & { role: AssignmentRoleType }> = ({ role, ...props }) => {
    switch (role) {
        case 'athlete':
            return <AthletesIconWrapper {...props} />;
        case 'coach':
            return <CoachesIconWrapper {...props} />;
        case 'parent':
            return <ParentsIconWrapper {...props} />;
    }
};

export default RoleTypeIcon;
